﻿/*
 * Purpose: Present T&Cs text with acceptance button below and optional validation label.
 * Boundary: Layout only; no state, side effects, or derived logic.
 * Invariants:
 * - Displays label above T&Cs text.
 * - Shows slim acceptance button below T&Cs text.
 * - Shows validation message only if enabled and options exist.
 * - ASCII only; no Unicode characters in comments or strings.
 */

// Imports
import { TcsTextDisplay, AcceptTermsButton } from './listofcheckboxes-controls';

// Component ListOfCheckboxesLayout:
// Stateless layout rendering T&Cs text with acceptance button and optional feedback
// Receives external state, handlers, and label from parent
export default function ListOfCheckboxesLayout({
    showValidationLabel,
    options,
    checked,
    onAcceptanceChange,
    isValid,
    label,
}) {
    // Rendering - container with label, T&Cs text, button, and validation text
    return (
        <div className="w-full space-y-2">
            {/* Label - optional title for section */}
            {label && (
                <label className="text-sm text-neutral-300">
                    {label}
                </label>
            )}

            {/* T&Cs text display - shows all options as text */}
            <div className="space-y-2">
                {options.map((option, index) => (
                    <TcsTextDisplay key={index} text={option} />
                ))}
            </div>

            {/* Acceptance button - slim button below T&Cs text */}
            <AcceptTermsButton
                checked={checked}
                onChange={onAcceptanceChange}
                disabled={false}
            />

            {/* Validation message - appears only when showValidationLabel is true */}
            {showValidationLabel && options.length > 0 && (
                <p
                    className={`mt-2 text-sm ${isValid ? 'text-emerald-600' : 'text-red-600'
                        }`}
                >
                    {isValid ? 'Terms accepted' : 'Please accept terms'}
                </p>
            )}
        </div>
    );
}